import { defineMessages } from 'react-intl';

const messages = defineMessages({
  editItemModalHeader: {
    description: 'Header for edit items modal',
    defaultMessage: 'Edit Shipment Items',
    id: 'nUXijB',
  },
  editItemInstructions: {
    description: 'Instructions for editing items for the current order in the current shipment',
    defaultMessage: 'Add or edit items to your order',
    id: 'NQklyg',
  },
  editItemsForCombinedShipmentInstructions: {
    description: 'Instructions for editing items for the current shipment',
    defaultMessage: 'Add or edit items to Order #{orderNumber} in this shipment. You can also add items for manual orders.',
    id: 'FMhq26',
  },
  saveButton: {
    description: 'Text for button prompting merchant to save changes',
    defaultMessage: 'Save Changes',
    id: '5JBmNY',
  },
  addItemButton: {
    description: 'Text prompting merchant to add item to the current shipment',
    defaultMessage: '{icon} <span>Add Item</span>',
    id: 'actGWr',
  },
  splitShipDisabledMessage: {
    description: 'Message informing the merchant that the current line item is disabled because it is a split item',
    defaultMessage: 'Split items cannot be edited',
    id: 'lQQ7oc',
  },
  marketplaceOrderDisabledMessage: {
    description: 'Message informing user that the current item cannot be edited because it came from a marketplace',
    defaultMessage: 'Marketplace items cannot be edited',
    id: 'dciXFk',
  },
  defaultSaveErrorMessage: {
    description: 'Default message shown when there is an error saving the update',
    defaultMessage: 'There was an error attempting to save your changes',
    id: 'vOXqck',
  },
  invalidQuantityErrorMessage: {
    description:
      'Error message indicating that the user must provide a quantity value for their shipment items that is greater than or equal to 1',
    defaultMessage: 'Item quantities must be greater than or equal to 1',
    id: '5PBEhT',
  },
  missingNameFieldErrorMessage: {
    description: 'Error message indicating that the user must provide a non-empty name value for their shipment items',
    defaultMessage: 'All items must have a "Name" value',
    id: 'l0amLU',
  },
  invalidAttemptToEditMarketplaceOrderErrorMessage: {
    description:
      'Error message indicating that the user is not allowed to make adjustments to shipments associated with an order that originated from a marketplace',
    defaultMessage: 'Items in this shipment cannot be adjusted because the order it fulfills originated from an external marketplace',
    id: 'xpcpv2',
  },
  invalidAttemptToEditFulfillmentPlanErrorMessage: {
    description: 'Error message indicating that the current shipment is uneditable',
    defaultMessage: "Items in this shipment cannot be adjusted because of the shipment's status",
    id: 'llM3V7',
  },
  invalidAttemptToEditSplitItemErrorMessage: {
    description: 'Error message indicating that an item the user attempted to edit was previously "split" and thus cannot be edited',
    defaultMessage: 'One or more of the edited items was previously split and cannot be edited',
    id: 'Bw7gu3',
  },
});

export default messages;
